import { Helpers } from '@front/utils/index';
import { createComponent } from '@front/utils/alpine';
const Menu = createComponent(() => ({
    context: '',
    toggle: false,
    isMobile() {
        return Helpers.Screen.isWiderThanBreakpoint('md') ? false : true;
    },
    getView() {
        if (this.isMobile() && this.context == this.$el.dataset.context) {
            this.toggle = !this.toggle;
        }
        else {
            window.location.href = this.$el.dataset.url;
        }
    },
}));
const Wishlist = createComponent(() => ({
    controller: new AbortController(),
    selectedProducts: [],
    allSelected: false,
    initialProductKeys: [],
    isModalOpen: false,
    modalTitle: '',
    modalDescription: '',
    isFormAction: false,
    action: '',
    actionRoute: '',
    productLabelSingular: '',
    productLabelPlural: '',
    wishlistId: 0,
    variantKey: '',
    productCount() {
        return this.initialProductKeys.length;
    },
    productLabel() {
        return this.productCount() > 1
            ? this.productLabelPlural
            : this.productLabelSingular;
    },
    toggleAll() {
        this.allSelected = !this.allSelected;
        if (this.allSelected) {
            this.selectedProducts = [...this.initialProductKeys];
        }
        else {
            this.selectedProducts = [];
        }
    },
    updateAllSelected() {
        this.allSelected =
            this.selectedProducts.length === this.initialProductKeys.length;
    },
    async removeProduct() {
        const csrfToken = JSON.parse(document
            .querySelector('meta[name="app"]')
            .getAttribute('content')).token;
        this.controller.abort();
        this.controller = new AbortController();
        const formData = new FormData();
        formData.append('variant_key', this.variantKey);
        formData.append('wishlist_id', this.wishlistId.toString());
        const response = await fetch(this.actionRoute, {
            method: 'POST',
            body: formData,
            headers: {
                Accept: 'application/json',
                'X-CSRF-TOKEN': csrfToken || '',
            },
            signal: this.controller.signal,
        });
        const json = await response.json();
        if (!response.ok) {
            throw new Error(`Error! status: ${response.status}`);
        }
        if (json.success && json.data && json.data.variant) {
            const variantKey = json.data.variant;
            console.log(variantKey);
            const productDiv = document.querySelector(`.js-wishlist-product-${variantKey}`);
            if (productDiv) {
                productDiv.remove();
            }
            this.selectedProducts = this.selectedProducts.filter((key) => key !== variantKey);
            this.initialProductKeys = this.initialProductKeys.filter((key) => key !== variantKey);
            this.updateAllSelected();
        }
        return json;
    },
    confirmAction() {
        if (this.action == 'removeProduct') {
            this.removeProduct();
        }
        this.closeModal();
    },
    prepareModal(title, description, action, actionRoute, isFormAction, wishlistId, variantKey) {
        this.isModalOpen = true;
        this.modalTitle = title;
        this.modalDescription = description;
        this.action = action || '';
        this.actionRoute = actionRoute || '';
        this.isFormAction = isFormAction;
        this.wishlistId = wishlistId || 0;
        this.variantKey = variantKey || '';
    },
    closeModal() {
        this.isModalOpen = false;
        this.isFormAction = false;
        this.action = '';
        this.actionRoute = '';
        this.wishlistId = 0;
        this.variantKey = '';
    },
    getSelectedProductsWithVariants() {
        return this.selectedProducts.map((variantKey) => {
            const splitted = variantKey.split('-');
            const productId = parseInt(splitted[0]);
            const variantInput = document.querySelector(`.js-wishlist-product-${variantKey}-variant`);
            const quantityInput = document.querySelector(`.js-wishlist-product-${variantKey}-quantity`);
            return {
                color_id: null,
                product_id: productId,
                variant_id: variantInput ? Number(variantInput.value) : null,
                quantity: quantityInput ? Number(quantityInput.value) : 0,
            };
        });
    },
}));
const Users = { Menu, Wishlist };
export { Users };
